import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';


const updateDayType = async ({ finalFormValidation, state, userId, updateState, editResourceDayType, Toast, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const { itemDetails } = state;
  const { dayTypeId, resourceDayType, dayTypeComment, myDayTypeComment } = itemDetails;
  const { resourceId, approved, daysRequestId, unionId, contractId, contractRulesGroupId, salaryLevelId, TKComment, jobSalaryId, hourlyActivityRateFlag, rate, jobSalaryUpgradeId, resourceDayTypeId } = resourceDayType;
  const date = moment(resourceDayType.date).add(4, 'hours').format('YYYY-MM-DD');
  const parameters = {
    date,  // chosen on form
    dayTypeId, // chosen on form
    resourceId,
    approved,
    comment: dayTypeComment || ' ',
    myComment: myDayTypeComment || ' ',
    daysRequestId,
    userId,
    unionId,
    contractId,
    contractRulesGroupId,
    salaryLevelId,
    TKComment: ' ',
    jobSalaryId,
    hourlyActivityRateFlag,
    rate,
    jobSalaryUpgradeId,
    resourceDayTypeId,
    };
    // store dayType parameters for optimistic re-ender
    itemDetails.dayTypeParams = parameters;
    await updateState({itemDetails});
    // now edit existing resource day type
    const { resource } = state;
    const day = moment(date).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: 'Resource Day Type Updated', description: `For ${resource.name} on ${day}`};
    try {
      await editResourceDayType(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'editResourceDayType',
            message: parseError(error)
          }
        });
        console.log(error);
          notification = {
            type: 'error',
            message: "Updating Resource Day Type Failed",
            description: `For [${resource.name} on ${day}]: ${parseError(error)}`
          };
        }
    }
    Toast(notification);
    refreshPage();

}

export default updateDayType;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/dayType/updateDayType.js